import { z } from 'zod';
import { SegmentSettingSchema } from './messageTemplate';

export const MessageCategoryConfigSchema = z.object({
  id: z.number().int(),
  key: z.string(),
  name: z.string(),
  parentId: z.number().int().nullable(),
});

export type MessageCategoryConfig = z.infer<typeof MessageCategoryConfigSchema>;

const MetaNotificationSettingsSchema = z.object({
  notification: z.object({
    pushEnabled: z.boolean(),
  }),
});

const MetaActionSchema = z.object({
  type: z.string(),
});

export const MessageTemplateMetaSchema = z.object({
  messageCategories: z.array(MessageCategoryConfigSchema),
  segments: z.array(SegmentSettingSchema),
  notificationSettings: MetaNotificationSettingsSchema,
  actions: z.array(MetaActionSchema),
});

export type MessageTemplateMeta = z.infer<typeof MessageTemplateMetaSchema>;
